import config from "../../config/config";
var MEDIA = "/v1/media";
var ATTACHMENT = "/v1/attachments";
export var updateMediaDetails = function (values) {
    var mediaId = values.mediaId, data = values.data, enabled = values.enabled, setError = values.setError, orgId = values.orgId;
    if (mediaId && enabled) {
        fetch("" + config.API_URL + MEDIA + "/" + mediaId, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Organization-Identification': orgId || ""
            },
            credentials: "include",
            body: JSON.stringify(data),
        })
            .then(function (res) { return res.json(); })
            .then(function (data) {
            (data === null || data === void 0 ? void 0 : data.error) ? setError(data === null || data === void 0 ? void 0 : data.message) : setError("");
        })
            .catch(function (error) { return setError("" + error); });
    }
};
export var updateAttachmentDetails = function (values) {
    var attachmentId = values.attachmentId, data = values.data, enabled = values.enabled, setError = values.setError, orgId = values.orgId;
    if (attachmentId && enabled) {
        fetch("" + config.API_URL + ATTACHMENT + "/" + attachmentId, {
            method: "PATCH",
            headers: {
                'Content-Type': 'application/json',
                'Organization-Identification': orgId || ""
            },
            credentials: "include",
            body: JSON.stringify(data),
        })
            .then(function (res) { return res.text(); })
            .then(function (text) { return text ? JSON.parse(text) : {}; })
            .then(function (data) {
            (data === null || data === void 0 ? void 0 : data.error) ? setError(data === null || data === void 0 ? void 0 : data.message) : setError("");
        })
            .catch(function (error) { return setError("" + error); });
    }
};
